import { render, staticRenderFns } from "./geniusClub.vue?vue&type=template&id=3404c92a&scoped=true"
import script from "./geniusClub.vue?vue&type=script&lang=js"
export * from "./geniusClub.vue?vue&type=script&lang=js"
import style0 from "./geniusClub.vue?vue&type=style&index=0&id=3404c92a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404c92a",
  null
  
)

export default component.exports